import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@cxm/ui/styles.css";
import OnboardWidget from "@cxm/ui/components/onboard-widget";
import { client } from "@cxm/client";
import { createRoot } from "react-dom/client";
import React from "react";
import { getEmbeddedWidgetReferralTag } from "./widget-referral-tag";

const queryClient = new QueryClient();

client.setConfig({
  baseURL: "https://api.cxmloans.com/",
});
//
//class HabitatApp extends ReactHabitat.Bootstrapper {
//  constructor() {
//    super();
//
//    // Create a new container builder:
//    const builder = new ReactHabitat.ContainerBuilder();
//
//    (window as any).updateHabitat = this.update.bind(this);
//
//    // Register a component:
//    builder.register(() => (
//      <QueryClientProvider client={queryClient}>
//        <OnboardWidget isLoggedIn={false} baseUrl={"https://cxmloans.com"} />
//      </QueryClientProvider>
//    )).as("OnboardWidget");
//
//    try {
//      // Finally, set the container:
//      this.setContainer(builder.build());
//    } catch (err) {
//      console.log("habitat error. ignorable");
//    }
//    // Finally, set the container:
//  }
//}
//
//// Always export a 'new' instance so it immediately evokes:
//export default new HabitatApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

const element = document.getElementById("cxm-widget-root");

if (element) {
  createRoot(element).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <OnboardWidget
          isLoggedIn={false}
          baseUrl={"https://cxmloans.com"}
          referralTag={getEmbeddedWidgetReferralTag(element)}
        />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
